export default __webpack_public_path__ + "static/media/mobile-tour-history-img.12ac6530.svg";